export default "__VITE_ASSET__or7pCjBl__"